<template>
	<div class="assemble-sound">
		<speaker-notes :notes="currentNotes"></speaker-notes>
		<h2>Implementation - AudioBuffer</h2>
		<flow-chart selected="buffer"></flow-chart>
		<div class="code">
		<code :class="`p${part}`">
			const ac = activeAudioContext(); // AudioContext<br>
			const rate = ac.sampleRate; // usually 44,100 or 48,000<br>
			const tempo = <span class="b3">rate * tempoMultiplier;</span><br>
			const len = lenInSec * rate;<br>
			let buff = ac.<span class="b1">createBuffer</span>(1, len, rate); // <span class="b1">AudioBuffer</span><br>
			let chanData = buff.<span class="b2">getChannelData(0)</span>; // <span class="b2">Float32Array</span><br>
			const start = <span class="b3">Math.floor(note.start*tempo)</span>;<br>
			const end = <span class="b3">Math.floor(note.end*tempo)</span>;<br>
			const pitch = <span class="b4">fontCache</span>[note.name].<span class="b4">getChannelData(0)</span>;<br>
			for (let i = start; i &lt; end; i++)<br>
			&nbsp;&nbsp;chanData[i] = <span class="b5">pitch[i-start] * note.volume / 128</span>;<br>
		</code>
		</div>
	</div>
</template>

<script>
	import PageParts from "../helpers/page-parts";
	import FlowChart from "../components/FlowChart";
	import SpeakerNotes from "../components/SpeakerNotes";
	export default {
		name: "assemble-sound",
		components: {SpeakerNotes, FlowChart},
		mixins: [
			PageParts,
		],
		data() {
			return {
				notes: [
					[
						"Simplest example of creating the audio buffer by hand.",
						"You can get more sophisticated with using filters.",
						"Do this for each track.",
						"As many tracks as you want.",
					],
					[
						"Then we get access to the buffer so we can write in it.",
					],
					[
						"For each note, get start and end place.",
						"The sample rate is whatever the system supports.",
						"This sets the tempo.",
					],
					[
						"Get the note from the sound font.",
						"Put in a cache.",
						"Do all network traffic upfront.",
						"Most pieces use the same notes over and over.",
						"'Pitch' now contains an array of sound samples.",
					],
					[
						"This is simplified.",
						"More processing can be done w/math or built in filters.",
						"Shows that there is no magic in the buffer - just a collection of numbers.",
						"We are setting the overall volume.",
						"If you have two notes to blend, this is where you really want a filter to make it sound good.",
					],
				]
			};
		},
	}
</script>

<style lang="scss" scoped>
	.assemble-sound {
		display: flex;
		flex-direction: column;
		align-items: center;
	}
	.code {
		display: flex;
		margin-top: 20px;
	}
</style>
